<template>
  <div>
    <div class="text-right">
      <el-button type="primary" size="mini" @click="dialogVisible = true">
        Create Product
      </el-button>
    </div>
    <el-dialog title="Create Product" :visible.sync="dialogVisible">
      <el-form :model="form" :rules="rules" ref="form" @submit.prevent.native="onSubmit">
        <el-form-item label="Product title" prop="title">
          <el-input v-model="form.title" placeholder="Enter a product title"></el-input>
        </el-form-item>
        <el-form-item label="Category" prop="category">
          <app-categories v-model="form.category" />
        </el-form-item>
        <el-form-item label="Brand" prop="brand">
          <app-brands v-model="form.brand" />
        </el-form-item>
        <div class="row">
          <div class="col-12 col-md-6">
            <el-form-item label="Barcode" prop="barcode_value">
              <el-input v-model="form.barcode_value" class="input-select">
                <el-select v-model="form.barcode_type" slot="append" placeholder="Select barcode type">
                  <el-option label="EAN" value="EAN"></el-option>
                  <el-option label="UPC" value="UPC"></el-option>
                </el-select>
              </el-input>
            </el-form-item>
          </div>
          <div class="col-12 col-md-6">
            <el-form-item label="Country (Made In)">
              <app-countries v-model="form.country_id" />
            </el-form-item>
          </div>
        </div>
        <el-form-item label="Product description" prop="desc">
          <el-input v-model="form.desc" type="textarea" rows="5" placeholder="Enter a product description"></el-input>
        </el-form-item>
        <el-button native-type="submit" type="primary" :loading="loading">Save</el-button>
        <el-button @click="onCancel">Cancel</el-button>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import AppBrands from '@/components/App/AppBrands'
import AppCategories from '@/components/App/AppCategories'
import AppCountries from '@/components/App/AppCountries'

export default {
  components: {
    AppBrands,
    AppCategories,
    AppCountries,
  },

  data() {
    return {
      loading: false,
      dialogVisible: false,
      form: {
        barcode_value: null,
        barcode_type: 'EAN',
        brand: null,
        category: null,
        country_id: null,
        currency: 'MYR',
        desc: null,
        title: null,
      },
      rules: {
        'barcode_value': [
          { required: true, message: 'Enter the product barcode.', trigger: 'blur' },
        ],
        'brand': [
          { required: true, message: 'Select a brand.', trigger: 'blur' },
        ],
        'category': [
          { required: true, message: 'Select a category.', trigger: 'blur' },
        ],
        'desc': [
          { required: true, message: 'Enter a product description.', trigger: 'blur' },
          { min: 140, max: 280, message: 'Length should be 140 to 280.', trigger: 'blur' },
        ],
        'title': [
          { required: true, message: 'Enter a product title.', trigger: 'blur' },
          { max: 64, message: 'Length should be up to 64.', trigger: 'blur' },
        ],
      },
    }
  },

  methods: {
    onSubmit() {
      this.$refs['form'].validate(async valid => {
        if (!valid) {
          return false
        }

        this.loading = false

        try {
          var { data } = await this.$http.post(`/products`, this.form)
        } catch(err) {
          this.$message.error(err.response.data.message)
          return false
        } finally {
          this.loading = false
        }

        this.$router.push({ name: 'products-id', params: { id: data.product.id } })
        this.$message.success(data.message)
      })
    },

    onCancel() {
      this.dialogVisible = false
      this.$refs['form'].resetFields()
    },
  },
}
</script>

<style>
.input-select .el-input-group__append {
  width: 100px;
  padding: 0;
}

.input-select .el-select {
  margin: -10px 0;
  text-align: right;
}
</style>
